import { gql } from 'graphql-tag';

export const performanceCategoriesQuery = gql`
  query performanceCategories {
    scenkonstOtPerformanceCategories {
      id
      name
      children {
        id
        name
        performances {
          id
        }
      }
    }
  }
`;
